import { useState } from 'react';
import { getEnvironment, envMap } from '@/utils/Mobile';
import { Display } from '@/components/Display/Display';
import { Hide } from '@/components/Hide';
import MyIcon from '@/components/MyIcon';
import s from './style.module.scss';
import MobileDynamicForm from './MobileDynamicForm';
import Webdynamicform from './WebDynamicForm';
import { CheckCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { inject, observer } from 'mobx-react';
import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
const env = getEnvironment();
const Recommendclarification = (props) => {
    const { sessionStore, chatStore } = props.store;
    const { changeOriginMsgMap, getCurSessionMsgs, currentSessionMapId } = sessionStore;
    const { createRequestByMsgId } = chatStore;
    const { personalized_recommend_clarification, messageInfo } = props;
    const {
        profile_fields = [],
        need_topic = false,
        need_profile = false,
        topic_value = '',
        filled = false
    } = personalized_recommend_clarification || {};
    const [expand, setExpand] = useState(true);
    const toggleExpand = () => {
        setExpand(!expand);
    };
    const changeData = (data, currentSessionId) => {
        let msgs = getCurSessionMsgs();
        let len = msgs.length;
        if (len) {
            let obj = msgs[len - 1].personal_recommend_result.personalized_recommend_clarification || {};
            msgs[len - 1].personal_recommend_result.personalized_recommend_clarification = { ...obj, ...data };
        }
        changeOriginMsgMap({
            [currentSessionId]: {
                messages: msgs
            }
        });
    };
    const onSubmit = (formData) => {
        profile_fields.forEach((item) => {
            item.value = formData[item.en_name];
        });
        let questionData = {
            need_topic: personalized_recommend_clarification?.need_topic,
            topic_value: formData?.topic_value || '',
            profile_fields: profile_fields,
            original_intent: 'meta_query',
            filled: true
        };
        let reqData = {
            question: JSON.stringify(questionData),
            tenant_id: messageInfo?.tenant_id,
            user_id: messageInfo?.user_id,
            agent_id: messageInfo?.agent_id,
            skill_id: messageInfo?.skill_id,
            session_id: messageInfo?.session_id,
            interrupt: true,
            originQuestion: messageInfo?.question
        };
        setExpand(false);
        changeData(questionData, currentSessionMapId);
        createRequestByMsgId(messageInfo?._id || messageInfo?.temId, reqData); //历史记录去id，新消息去临时temId
    };
    return (
        <>
            <div className={s['add-info-wrap']}>
                <div className={s['tip-text']}>
                    <GrtAiMarkdown className={s['tip-text']} content={'为了更精准地推荐，请补充以下信息'}></GrtAiMarkdown>
                </div>
                <div className={s['info-content']}>
                    <div className={s['group-title']}>
                        <div className={s['left']}>
                            <MyIcon className={s['text-icon']} type="icon-add-info"></MyIcon>
                            <span className={s['text']}>
                                补充信息
                                <Display show={filled}>
                                    <span className={s['icon']}>
                                        <CheckCircleFilled style={{ color: '#52C41A' }} />
                                    </span>
                                </Display>
                            </span>
                        </div>

                        <Display show={!expand}>
                            <Tooltip title="展开">
                                <div className={s['expand']} onClick={toggleExpand}>
                                    <MyIcon type="icon-zhankai"></MyIcon>
                                </div>
                            </Tooltip>
                        </Display>
                        <Display show={expand}>
                            <Tooltip title="收起">
                                <div className={s['expand']} onClick={toggleExpand}>
                                    <MyIcon type="icon-shouqi"></MyIcon>
                                </div>
                            </Tooltip>
                        </Display>
                    </div>
                    <Hide show={expand}>
                        <Display show={env !== envMap.pc}>
                            <MobileDynamicForm
                                hasClarification={filled}
                                need_topic={need_topic}
                                need_profile={need_profile}
                                topic_value={topic_value}
                                data={profile_fields}
                                onSubmit={onSubmit}
                            />
                        </Display>
                        <Display show={env === envMap.pc}>
                            <Webdynamicform
                                hasClarification={filled}
                                need_topic={need_topic}
                                need_profile={need_profile}
                                topic_value={topic_value}
                                data={profile_fields}
                                onSubmit={onSubmit}
                            />
                        </Display>
                    </Hide>
                </div>
            </div>
        </>
    );
};

export default inject('store')(observer(Recommendclarification));
